import _reduce from 'lodash/reduce';

import actions from './actions';
import reducer from './reducer/search';
import types from './types';
import utilities from './utilities';

export const getReducer = () => reducer;
export const getActions = (options) =>
  _reduce(
    actions,
    (acc, action, actionName) => {
      acc[actionName] = action(options);

      return acc;
    },
    {}
  );
export const getTypes = () => types;
export const getUtilities = () => utilities;

export default {
  getReducer,
  getActions,
  getTypes,
  getUtilities,
};
